// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3fa85880","453":"10fb0d40"}[chunkId] + ".chunk.js";
};